import { gql } from "@apollo/client";

export const GET_REFUND_PAYMENT = gql`
query GetPaymentRes($page: Int, $limit: Int, $filter: String, $sort: userSort, $search: String, $from: String, $to: String, $status: String,$refundType: String) {
        getPaymentRes(page: $page, limit: $limit, filter: $filter, sort: $sort, search: $search, from: $from, to: $to, status: $status,refundType: $refundType) {
            count
            data {
                id
                cancelReason
                createdAt
                isActive
                 isRefund
                refundType
                customerId {
                    mobile
                }
        
                orderDetails {
                    id
                    status
                    order_number
                    pickupAddress {
                        name
                        phone
                        address1
                        city
                        stateId {
                            id
                            name
                        }
                        zipCode
                    }
                    deliveryAddress {
                        name
                        phone
                        address1
                        city
                        stateId {
                            id
                            name
                        }
                        zipCode
                    }
                    order_amount
                    awb_number
                    paymentSessionId
                    paymentStatus
                    orderId
                    order_id
                    trackStatus
                    courier_id
                    paymentDetails
                }
                isDeleted
                createdBy
            }
        }
    }
`

export const GET_DAILY_COUNT_PAYMENTREFUND = gql`
query MonthlyPaymentRefund {
  getPaymentCounts {
    monthlyPaymentRefund {
      count
      _id
    }
    dailyPaymentRefund {
      count
      _id
    }
  }
}
`

export const GET_REFUND_STATUS = gql`
  query GetRefundStatus($orderId: String) {
    getRefundStatus(orderId: $orderId) {
   cf_payment_id
  cf_refund_id
  created_at
  entity
  order_id
  processed_at
  refund_amount
  refund_arn
  refund_charge
  refund_currency
  refund_id
  refund_status
  refund_type
  status_description
    }
  }
`;